import * as React from 'react';



export const Checkbox: React.FunctionComponent<React.HTMLProps<HTMLInputElement>> = (props) => {
    return <input
        {...props}
        className={`${props.className || ""} mr-3`}
        type="checkbox" />
};